import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { history } from '../_state/helpers'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import studentPrivateRoutes from 'routes/studentPrivateRoutes'
import useSessionHeartbeat from '../Views/StudentPrivate/hooks/useSessionHeartbeat'
import { studentActions } from '../_state/actions'

function StudentSessionTracker() {
    useSessionHeartbeat()
    return null
}

const ACCEPT_TERMS_PATH = '/student/accept-terms'

const styles = (theme) => ({
    main: {
        //padding: '20px',
        margin: '60px 0px 0px 0px',
        [theme.breakpoints.down('sm')]: {
            margin: '60px 0px 0px 0px',
        },
    },
})

class StudentPrivateLayout extends React.Component {
    constructor(props) {
        super(props)
        if (!localStorage.getItem('authToken')) {
            console.log('StudentPrivateLayout does not have auth token available')
            history.push('/student/login')
            return
        }
        console.log('StudentPrivateLayout has authentication token and should render')

        history.listen((location, action) => {
            // clear alert on location change
            // dispatch(alertActions.clear());
        })
        if (!studentPrivateRoutes.find((x) => x.path === props.path)) {
            history.push('/student')
        }
    }

    componentDidMount() {
        // The gate can only decide once we have the user, and not every student page fetches it.
        // The lesson page in particular never did, so a deep link straight into a lesson would have
        // slipped past the gate entirely. Fetch it here so every student route is covered.
        const { student, dispatch } = this.props
        if (!student?.userInfo && !student?.fetchingUserInfo) {
            dispatch(studentActions.getStudentInfo('web'))
        }
    }

    render() {
        const { component: Component, classes, location, history, dispatch, computedMatch, student } = this.props

        // Privacy terms and conditions gate. userInfo is null until the first fetch resolves, so we
        // wait rather than redirecting, which avoids a flash on the way in. Deep links are preserved
        // because this is a route rather than a modal on the dashboard.
        const userInfo = student?.userInfo
        const mustAcceptTerms =
            userInfo && userInfo.termsGateEnabled === true && userInfo.termsAccepted === false
        const currentPath = location?.pathname

        if (mustAcceptTerms && currentPath !== ACCEPT_TERMS_PATH) {
            // Remember where they were headed so accepting takes them there rather than the dashboard
            return <Redirect to={{ pathname: ACCEPT_TERMS_PATH, state: { from: currentPath } }} />
        }

        // Once accepted, send them on. Without this they would sit on the gate page after accepting.
        if (userInfo && !mustAcceptTerms && currentPath === ACCEPT_TERMS_PATH) {
            const intendedPath = location?.state?.from
            const forwardTo = intendedPath && intendedPath !== ACCEPT_TERMS_PATH ? intendedPath : '/student'
            return <Redirect to={forwardTo} />
        }

        return (
            <div>
                <StudentSessionTracker />
                <div className={classes.main}>
                    <Component
                        location={location}
                        computedMatch={computedMatch}
                        history={history}
                        dispatch={dispatch}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { organization, user, student } = state
    return {
        user,
        organization,
        student,
    }
}

StudentPrivateLayout.propTypes = {
    classes: PropTypes.object.isRequired,
}

const enhance = compose(connect(mapStateToProps), withStyles(styles))

export default enhance(StudentPrivateLayout)
